import React from 'react'
import { Text, View } from 'react-native'
import PropTypes from 'prop-types'
import Image from 'react-native-scalable-image'
import * as ResourceManager from '../methods/ResourceManager'
import styles from '../../styles'

function DataSendingLightsDiagram(props) {
  const { t } = props
  return (
    <View style={{ padding: 16 }} testID="ugh">
      <View style={{
        flexDirection: 'row',
        paddingTop: 10,
      }}
      >
        <Image
          width={200}
          style={{ maxHeight: 50 }}
          source={{ uri: ResourceManager.loadImage('half_green_waves') }}
        />
        <View style={{ flexShrink: 1, justifyContent: 'center' }}>
          <Text
            maxFontSizeMultiplier={1}
            style={styles.lightsDescriptionText}
          >
            {t('common:collectingDataImageDesc')}
          </Text>
        </View>
      </View>
      <View style={{
        flexDirection: 'row',
        paddingTop: 10,
        paddingBottom: 10,
      }}
      >
        <Image
          width={200}
          style={{ maxHeight: 50 }}
          source={{ uri: ResourceManager.loadImage('all_green_waves') }}
        />
        <View style={{ flexShrink: 1, justifyContent: 'center' }}>
          <Text
            maxFontSizeMultiplier={1}
            style={styles.lightsDescriptionText}
          >
            {t('common:sendingDataImageDesc')}
          </Text>
        </View>
      </View>
    </View>
  )
}

DataSendingLightsDiagram.propTypes = {
  t: PropTypes.func.isRequired,
}

export default DataSendingLightsDiagram
